import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { URL_REQUESTS_PARTICIPANTS_LIST } from '@app/@core/constants/routes.constants';
import { UserType } from '@app/@core/constants/user-credentials.constants';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { CredentialsService } from '@app/login';
import {
  IntervenersDigitalSignatureDTO,
  IntervenientsDTO,
  IntervenientsSignatureDTO,
  SignatureSAMLResponseDTO,
} from '@app/requests/model/logalty-signature-model';
import { Operation } from '@app/requests/model/requests-model';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DigitalSignatureServiceStore } from '../digital-signature-service/digital-signature-service.store';
import { filter } from 'rxjs/operators';
import { DigitalSignatureCommonService } from '../digital-signature-service/digital-signature-common.service ';
import { DigitalSignatureServiceApi } from '../digital-signature-service/digital-signature-service-api.service';
import { DetectDeviceService } from '@app/@shared/services/utils/detect-device.service';

@UntilDestroy()
@Component({
  selector: 'scf-logalty-signature',
  templateUrl: './logalty-signature.component.html',
  styleUrls: ['./logalty-signature.component.scss'],
})
export class LogaltySignatureComponent implements OnInit {
  @ViewChild('frame') public iframe: ElementRef;
  @ViewChild('form') postForm: ElementRef;
  @Input('hasReturn') hasToolbar: boolean = true;

  /*
   ** [ESPSCFWMTS-4641] Due to a change of requirements this code is considered dead but it won't
   ** be removed until the EVO is confirmed to be valid.
   */
  // @HostListener('window:beforeunload', ['$event'])
  // @HostListener('window:popstate', ['$event'])
  // onCloseWindow(event: any) {
  //   console.log('BEFOREUNLOAD TRIGGERED!', event);
  //   this.digitalSignatureServiceStore.sendSignatureRejection().then((response) => {
  //     return response;
  //   });
  // }

  public signatureURL: SafeResourceUrl;
  public url: string;
  public saml: string;
  private reqBody: any;

  constructor(
    private sanitizer: DomSanitizer,
    private _http: HttpClient,
    public translate: TranslateService,
    private digitalSignatureServiceStore: DigitalSignatureServiceStore,
    private loaderGenericService: LoaderGenericService,
    private router: Router,
    private credentialsService: CredentialsService,
    public digitalSignatureCommonService: DigitalSignatureCommonService,
    public digitalSignatureService: DigitalSignatureServiceApi,
    private detectDeviceService: DetectDeviceService
  ) {
    this.reqBody = new FormData();
    this.reqBody.append('saml_assertion', this.saml);
    this.url = environment.URL_LOGALTY_SIGNATURE;
    this.signatureURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    /*
     ** [ESPSCFWMTS-4641] Due to a change of requirements this code is considered dead but it won't
     ** be removed until the EVO is confirmed to be valid.
     */
    // this.router.events
    //   .pipe(
    //     filter((event) => event instanceof NavigationStart),
    //     untilDestroyed(this)
    //   )
    //   .subscribe((event) => {
    //     this.digitalSignatureServiceStore.sendSignatureRejection().then((response) => {
    //       return response;
    //     });
    //   });
  }

  ngOnInit(): void {
    this.loaderGenericService.showSpinner();
    this.digitalSignatureServiceStore.SAMLObserver().subscribe((data: SignatureSAMLResponseDTO) => {
      console.log(data);
      if (data) {
        if (data && data.saml != null) {
          this.saml = data.saml;
        } else {
          let signatureEnd = JSON.parse(localStorage.getItem('signatureEnd'));
          if (signatureEnd && signatureEnd.saml == 'signature_end') {
            // firma acabada. No se redirige.
          }
        }
      }
    });
  }

  ngAfterViewInit() {
    this.postForm.nativeElement.submit();
    setTimeout(() => {
      this.loaderGenericService.stopSpinner();
    }, 800);
  }

  submitForm($event: any): boolean {
    $event.stopPropagation();
    this._http.post(this.url, this.reqBody);
    console.log(this.reqBody);
    return true;
  }

  onLoad() {
    console.log('onLoad hecho');
  }

  public goToPanel() {
    let operation: Operation = this.digitalSignatureCommonService.getOperation();
    let signatureDto: IntervenientsSignatureDTO = this.fillSignatureDTO(operation);
    let interveners: IntervenientsDTO[];
    this.digitalSignatureService
      .getParticipantsSignature(signatureDto)
      .subscribe((data: IntervenersDigitalSignatureDTO) => {
        interveners = data.interveners;
        if (
          (interveners != null || interveners != undefined) &&
          interveners.length > 1 &&
          !interveners.every((e: IntervenientsDTO) => {
            return e.document_result === '7';
          })
        ) {
          this.digitalSignatureServiceStore.manageSignature(
            operation,
            false,
            this.detectDeviceService.isAccessByDevice(),
            false
          );
        } else {
          let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
          this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);
        }
      });
  }

  private fillSignatureDTO(operation: Operation) {
    let signatureDto = {} as IntervenientsSignatureDTO;
    signatureDto.numOperation = operation.numOperation;
    signatureDto.language = 'es-' + operation.language;
    signatureDto.printContract = false;
    signatureDto.financialProduct = operation.finacialProduct;
    signatureDto.nameContract = operation.comarca;
    signatureDto.versionContract = operation.version;
    signatureDto.accessByDevice = 'N';
    signatureDto.isRestructuredLoan =
      operation.versionContract == 'V8' && operation.finacialProduct == '15' ? 'S' : 'N';
    return signatureDto;
  }
}
